// @flow
import { useContext } from 'react';
import { useMutation, MutationOptions, useQueryClient } from 'react-query';
import { AppContext } from 'contexts/AppContext';
import useUserProfileQuery from 'hooks/queries/useUserProfileQuery';
import { createAffordaDetails } from 'services/affordableService';
import QUERY_KEYS from 'constants/queryKeys';
import { UserContext } from 'contexts/UserContext';

type Props = {
  options: MutationOptions,
};

const useCreateAffordaPortalDetailsMutation = ({ options }: Props = {}) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const {
    authUser: { id },
  } = useContext(UserContext);
  const { refetch: refetchUserProfile } = useUserProfileQuery();
  const queryClient = useQueryClient();
  const hasRequiredParams = Boolean(organizationId && propertyId);

  return useMutation(
    async (requestData) => {
      const { data: userProfile } = await refetchUserProfile();
      await createAffordaDetails(organizationId, propertyId, {
        portalUserId: userProfile.portalUserId,
        ...requestData,
      });
    },
    {
      ...options,
      onSuccess: async (response) => {
        await queryClient.invalidateQueries(
          QUERY_KEYS.affordaDetails({ authUserId: id }),
        );
        options?.onSuccess(response);
        return response;
      },
      enabled: options?.enabled
        ? options.enabled && hasRequiredParams
        : hasRequiredParams,
    },
  );
};

export default useCreateAffordaPortalDetailsMutation;
